<div class="w-screen max-w-2xl"></div>
<div class="text-xl font-bold mb-4">{{ mode === 'add' ? 'Add' : 'Edit' }} Timeline Milestone</div>

<form [formGroup]="addTimelineMilestoneForm" (ngSubmit)="onSubmit()">
  <div class="grid grid-cols-2 gap-5">
    <div>
      <div class="text-xs">Category</div>
      <ng-select
        class="select select__big"
        formControlName="milestone_category_id"
        [clearable]="false"
        [searchable]="false"
        auxFormError
        label="Category"
      >
        <ng-option
          *ngFor="let milestoneCategory of milestoneCategoryQuery.selectAll() | async"
          [value]="milestoneCategory.id"
        >
          {{ milestoneCategory.name }}
        </ng-option>
      </ng-select>
    </div>

    <aux-input
      label="Milestone Name"
      formControlName="name"
      validators="required"
      #name
    ></aux-input>

    <aux-input
      label="Start Date"
      formControlName="contract_start_date"
      [type]="'date'"
      placeholder="YYYY-MM-DD"
      validators="required"
    ></aux-input>

    <aux-input
      label="End Date"
      formControlName="contract_end_date"
      [type]="'date'"
      placeholder="YYYY-MM-DD"
      validators="required"
    ></aux-input>

    <div>
      <div class="text-xs">Track From</div>
      <ng-select
        class="select select__big"
        formControlName="track_from_milestone_id"
        [clearable]="true"
        [searchable]="true"
        [appendTo]="'body'"
        auxFormError
        label="Track From"
      >
        <ng-option *ngFor="let milestone of trackFromMilestones$ | async" [value]="milestone.id">
          {{ milestone.name }}
        </ng-option>
      </ng-select>
    </div>

    <aux-input label="Description" formControlName="description"></aux-input>
  </div>

  <div class="flex space-x-4 mt-4">
    <button class="text-sm font-normal btn btn--blue w-32" type="submit">
      {{ mode === 'add' ? 'Add' : 'Update' }}
    </button>
    <button
      class="text-sm font-normal aux-link focus:outline-none"
      (click)="onCancel()"
      type="button"
    >
      Cancel
    </button>
  </div>
</form>
